var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-table"},[_c('el-table',{attrs:{"data":_vm.data,"height":"500"}},_vm._l((_vm.col),function(item,index){return _c('my-column',{key:index,attrs:{"col":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }